import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { Props as ReactModalProps } from 'react-modal';
import Modal from 'components/Modal/index';
import { IAppState } from 'types/app';
import { ExceptionalFriendWizardStep } from 'types/fate';
import Blurb from 'components/ExceptionalFriendModal/Blurb';
import Payment from 'components/ExceptionalFriendModal/Payment';
import Success from 'components/ExceptionalFriendModal/Success';
import { fetch as fetchMap } from 'actions/map';
import { fetchAvailable } from 'actions/storylet/index';

export interface Props extends ReactModalProps {
  disableTouchEvents?: boolean,
  dispatch: Function,
  onRequestClose: (_?: any) => void,
}

export function ExceptionalFriendModal(props: Props) {
  const { disableTouchEvents } = props;

  const [hasSuccessfullySubscribed, setHasSuccessfullySubscribed] = useState(false);
  const [successMessage, setSuccessMessage] = useState<string | undefined>(undefined);
  const [wizardStep, setWizardStep] = useState(ExceptionalFriendWizardStep.Blurb);

  const handleRequestClose = () => {
    const { dispatch } = props;
    if (hasSuccessfullySubscribed) {
      dispatch(fetchMap());
      dispatch(fetchAvailable());
    }
    props.onRequestClose(hasSuccessfullySubscribed);
  };

  const handleAfterClose = () => {
    // Clean up internal state
    setHasSuccessfullySubscribed(false);
    setSuccessMessage(undefined);
    setWizardStep(ExceptionalFriendWizardStep.Blurb);
  };

  const onNext = useCallback((message?: string) => {
    switch (wizardStep) {
      case ExceptionalFriendWizardStep.Blurb:
        return setWizardStep(ExceptionalFriendWizardStep.Payment);
      case ExceptionalFriendWizardStep.Payment:
        setHasSuccessfullySubscribed(true); // We will pass this up to the component that summoned us
        setSuccessMessage(message);
        return setWizardStep(ExceptionalFriendWizardStep.Success);
      case ExceptionalFriendWizardStep.Success:
      case ExceptionalFriendWizardStep.Error:
      default:
        return;
    }
  }, [wizardStep]);

  const renderContent = () => {
    switch (wizardStep) {
      case ExceptionalFriendWizardStep.Blurb:
        return <Blurb onNext={onNext} />;
      case ExceptionalFriendWizardStep.Payment:
        return <Payment onNext={onNext} />;
      case ExceptionalFriendWizardStep.Success:
        return <Success message={successMessage} onNext={onNext} />;
    }
  };

  return (
    <Modal
      isOpen={props.isOpen}
      onAfterClose={handleAfterClose}
      onRequestClose={handleRequestClose}
      overlayClassName="modal--map-exceptional-friend-modal__overlay"
      className="modal--map-exceptional-friend-modal__content"
      disableTouchEvents={disableTouchEvents}
    >
      {renderContent()}
    </Modal>
  );
}

ExceptionalFriendModal.displayName = 'ExceptionalFriendModal';

const mapStateToProps = ({ fate }: IAppState) => ({ data: fate.data });

export default connect(mapStateToProps)(ExceptionalFriendModal);